// extracted by mini-css-extract-plugin
export default {"carousel":"ImageCarousel_carousel__ACKfw","carousel-inner":"ImageCarousel_carousel-inner__RlE1g","carousel-img":"ImageCarousel_carousel-img__NoWq9"};